/**
 * The newcomer's chosen start, carried across sign-in (owner feedback
 * 2026-09-28): "No website" on the sign-in screen leads to the email form,
 * and the org-setup step then preselects "A page from us", so onboarding
 * offers the FinderlyFix-hosted widget page (finderlyfix.com/p/…) first.
 *
 * Browser storage only, and only a hint: private windows and blocked storage
 * fall back to the default ("On my website"), which still offers the page.
 */
export type StartPath = 'site' | 'page';

const KEY = 'fx-start-path';

export function rememberStartPath(path: StartPath): void {
  try {
    window.localStorage.setItem(KEY, path);
  } catch {
    /* storage blocked: the default applies */
  }
}

export function startPath(): StartPath {
  try {
    return window.localStorage.getItem(KEY) === 'page' ? 'page' : 'site';
  } catch {
    return 'site';
  }
}

export function clearStartPath(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

/**
 * The installer step's saved answer (InstallOwner.tsx `fx-installer-{org}`):
 * set to "none" so a new organisation that chose a page from us lands on the
 * page form. Same JSON encoding as `useLocalState`.
 */
export function presetNoWebsite(orgId: string): void {
  try {
    window.localStorage.setItem(`fx-installer-${orgId}`, JSON.stringify('none'));
  } catch {
    /* ignore: the person picks it on the step */
  }
}
